var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlashMobileIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "FlashMobileIcon_svg__a",
    x: 0,
    y: 0,
    width: 48,
    height: 48,
    rx: 12
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "FlashMobileIcon_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#FlashMobileIcon_svg__a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#E74536",
    xlinkHref: "#FlashMobileIcon_svg__a"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#FlashMobileIcon_svg__b)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.938 4.313)"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#0F1941",
    cx: 21.5,
    cy: 21,
    r: 18.5
  }), /*#__PURE__*/React.createElement("circle", {
    fill: "#F7F5F0",
    cx: 18.5,
    cy: 18.5,
    r: 18.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.466 16.469h-2.525l2.838-13.554c.266-1.27-1.446-1.963-2.164-.877l-11.623 17.6c-.515.78.053 1.812.998 1.812H14l-3.93 10.62c-.407 1.102 1.034 1.944 1.82 1.062l13.35-14.975c.586-.657.113-1.688-.775-1.688z",
    fill: "#FFB511"
  }))))));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDgiIGhlaWdodD0iNDgiIHZpZXdCb3g9IjAgMCA0OCA0OCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayI+CiAgICA8ZGVmcz4KICAgICAgICA8cmVjdCBpZD0id2wzbHlqN3BjYSIgeD0iMCIgeT0iMCIgd2lkdGg9IjQ4IiBoZWlnaHQ9IjQ4IiByeD0iMTIiLz4KICAgIDwvZGVmcz4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPG1hc2sgaWQ9ImswdDltcXIxZWIiIGZpbGw9IiNmZmYiPgogICAgICAgICAgICA8dXNlIHhsaW5rOmhyZWY9IiN3bDNseWo3cGNhIi8+CiAgICAgICAgPC9tYXNrPgogICAgICAgIDx1c2UgZmlsbD0iI0U3NDUzNiIgeGxpbms6aHJlZj0iI3dsM2x5ajdwY2EiLz4KICAgICAgICA8ZyBtYXNrPSJ1cmwoI2swdDltcXIxZWIpIj4KICAgICAgICAgICAgPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMy45MzggNC4zMTMpIj4KICAgICAgICAgICAgICAgIDxjaXJjbGUgZmlsbD0iIzBGMTk0MSIgY3g9IjIxLjUiIGN5PSIyMSIgcj0iMTguNSIvPgogICAgICAgICAgICAgICAgPGNpcmNsZSBmaWxsPSIjRjdGNUYwIiBjeD0iMTguNSIgY3k9IjE4LjUiIHI9IjE4LjUiLz4KICAgICAgICAgICAgICAgIDxwYXRoIGQ9Ik0yNC40NjYgMTYuNDY5aC0yLjUyNWwyLjgzOC0xMy41NTRjLjI2Ni0xLjI3LTEuNDQ2LTEuOTYzLTIuMTY0LS44NzdsLTExLjYyMyAxNy42Yy0uNTE1Ljc4LjA1MyAxLjgxMi45OTggMS44MTJIMTRMMTAuMDcgMzIuMDdjLS40MDcgMS4xMDIgMS4wMzQgMS45NDQgMS44MiAxLjA2MmwxMy4zNS0xNC45NzVjLjU4Ni0uNjU3LjExMy0xLjY4OC0uNzc1LTEuNjg4eiIgZmlsbD0iI0ZGQjUxMSIvPgogICAgICAgICAgICA8L2c+CiAgICAgICAgPC9nPgogICAgPC9nPgo8L3N2Zz4K";
export { SvgFlashMobileIcon as ReactComponent };